import { UpdateStoryDiscussionMeta, UpdateStoryDiscussionPayload } from 'types/store/UpdateStoryDiscussion';
import { createAsyncReducer } from 'utils/Redux';

import { updateStoryDiscussionActions } from '../actions';

export default createAsyncReducer<UpdateStoryDiscussionMeta, UpdateStoryDiscussionPayload>(updateStoryDiscussionActions);
